<template>
    <div class="detail">
        <template v-if="!loading">
            <div class="content_title">{{detail.title}}</div>
            <div class="content" v-html="detail.content"></div>
        </template>
        <div v-else class="loading"></div>
    </div>
</template>

<script>
export default {
    name: "detail",
    data() {
        return {
            loading: false,
            detail: {},
        };
    },
    computed: {
    },
    components: {
        
    },
    mounted() {
        
    },
    destroyed() {},
    watch: {
        '$route.params.menuId': {
            handler: 'getMenuDetail',
            immediate: true
        },
        '$route.params.Listid': {
            handler: 'getListDetail',
            immediate: true
        }
    },
    methods: {
        getMenuDetail(val){
            if(val){
                this.loading = true;
                this.detail = {};
                this.$store.dispatch('getDetail', {menu_id: val}).then((result)=>{
                    this.detail = {
                        title: result.title,
                        content: result.content,
                    };
                    this.loading = false;
                });
            }
        },
        getListDetail(val){
            if(val){
                this.loading = true;
                this.detail = {};
                this.$store.dispatch('getDetail', {id: val}).then((result)=>{
                    this.detail = {
                        title: result.title,
                        content: result.content,
                    };
                    this.loading = false;
                });
            }
        }
    },
};
</script>

<style scoped lang="scss">
.detail{
    width: 910px;
    margin-left: 56px;
    .content{
        /deep/{
            p{
                text-indent: 2em !important;
                line-height: 1.8 !important;
                font-size: 16px !important;
            }
        }
    }
    @media only screen and (max-width: 1024px) {
        width: 100%;
        margin: 0;
        .content{
            /deep/{
                p{
                    font-size: .24rem !important;
                }
            }
        }
    }
}
</style>